import React, { useEffect, useState, useRef } from "react";
import {
    Row,
    Col,
    Card,
    Button,
    Container,
    CardBody,
    CardImg,
    CardText,
    Badge,
    CardTitle,
    Modal, ModalHeader, ModalBody, ModalFooter
} from "reactstrap";
import { AvForm, AvField } from 'availity-reactstrap-validation';
import Select from "react-select";
import FileUpload from "components/Common/file-upload/file-upload.component";
import Language from "Enums/Language"
import SelectOptions from "components/SelectOptions"
import { SuccessCreated, SuccessOk } from "configs/statusCode";
import { toast } from 'react-toastify';
import { salesDeveloperPrefix } from "configs/routePrefix";
import { floors, bathrooms, bedrooms, years, payment_methods } from "Enums/fixedData"
import blankImg from "assets/images/blank.png";
import CancelModal from "../CancelModal"
import { useDispatch, useSelector } from "react-redux";
import { appendFilters } from "store/adminFilter/actions";
import BuildingService from "services/SalesDeveloper/BuildingService";
import CategoriesService from "services/SalesDeveloper/CategoriesService";
const languages = ["en", "ar", "zh", "ru"]
const initialData = {
    selectedCatogory: null,
    en: "",
    ar: "",
    ru: "",
    zh: "",
    descrip_en: "",
    descrip_ar: "",
    descrip_zh: "",
    descrip_ru: "",
    floor_num: "",
    title_before_numbers: '',
    to: "",
    from: ""
}
const BuildingForm = (props) => {
    const filterData = useSelector(state=> state.adminFilter)
    const [uploadState, setUploadState] = useState(false)
    const [loading, setLoading] = useState(false)
    const [goOut, setGoOut] = useState(false)
    const [addNew, setAddNew] = useState(false)
    const [modal, setModal] = useState(false)
    const [editBuilding, setEditBuilding] = useState(null)
    const buildingService = new BuildingService()
    const [formData, setFormData] = useState(initialData)
    const [mediaIds, setMediaIds] = useState([])
    const [catogoryOptions, setCatogoryOptions] = useState([])
    const formRef = useRef()
    const dispatch = useDispatch()

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        })
        dispatch(appendFilters({addBuilding: 'addBuilding'}))
    }, [])

    useEffect(() => {
        if (editBuilding) {
            setFormData({
                ar: editBuilding.name.ar,
                en: editBuilding.name.en,
                ru: editBuilding.name.ru,
                zh: editBuilding.name.zh,
                descrip_ar: editBuilding.description.ar,
                descrip_en: editBuilding.description.en,
                descrip_ru: editBuilding.description.ru,
                descrip_zh: editBuilding.description.zh,
                floor_num: editBuilding.floor_num,
                selectedCatogory: editBuilding.selectedCatogory

            })

            setMediaIds(editBuilding ?.mediaIds)
        }
    }, [editBuilding])

    const handleFieldChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const deleteHandler = (id) => {
        buildingService.remove(id).then(response => {
            if (response && response.status === SuccessOk) {
                toast.success(response.data.success)
                props.deleteBuilding(id)
                if (editBuilding?.id === id) {
                     setFormData(initialData)
                    setEditBuilding(null)
                    setMediaIds([])
                }
            }
        })

    }
    const updatedAttachment = (attachments, type) => {
        setMediaIds([...mediaIds, ...attachments])
    }

    const deleteAttachment = (Items, type) => {
        let updatedMedia = mediaIds.filter(item => item.id != Items[0].id)
        setMediaIds(updatedMedia)
    }

    return (
        <AvForm ref={formRef} onValidSubmit={(e, v) => {
            if (!formData.selectedCatogory) {
                toast.error(" please select catogory")
                return
            }
            setLoading(true)
            const data = {
                description: {},
                floors_num: parseInt(formData.floor_num),
                compound_id: props.compoundId,
                categories_ids: [...formData.selectedCatogory.map(item => item.value)],
                images_ids: mediaIds.map(item => item.id)
            }

            if(filterData.addBuilding == "addBuilding"){
                data['name'] = {en: formData.en}
            }
            if(filterData.addBuilding == "addBuildings"){
                data['name'] = {en: formData.title_before_numbers}
                data['title_number_from'] = formData.from
                data['title_number_to'] = formData.to
            }

            languages.forEach(language => {
                if (formData[language] ?.length) {
                    data.name[language] = formData[language]
                }
            })
            languages.forEach(language => {
                if (formData[`descrip_${language}`] ?.length) {
                    data.description[language] = formData[`descrip_${language}`]
                }
            })
            if (editBuilding ?.id) {
                buildingService.update(editBuilding ?.id, data).then(response => {
                    if (response && response.status === SuccessOk) {
                        toast.success(" Building has been updated")
                        if (goOut) {
                            props ?.history ?.push(`${salesDeveloperPrefix}/compound/compound-list/${filterData?.developer_id}`);
                        } else if (addNew) {
                            setLoading(false)
                            props.updateBulidingList(editBuilding ?.id, {
                                ...data,
                                id: editBuilding ?.id,
                                mediaIds: mediaIds,
                                selectedCatogory: formData.selectedCatogory,
                                floor_num: formData.floor_num
                            })
                            setFormData(initialData)
                            setMediaIds([])
                            formRef.current.reset()
                            setAddNew(false)
                            setEditBuilding(null)
                        }
                        else {
                            props.updateBulidingList(editBuilding ?.id, {
                                ...data,
                                id: editBuilding ?.id,
                                mediaIds: mediaIds,
                                selectedCatogory: formData.selectedCatogory,
                                floor_num: formData.floor_num
                            })
                            setEditBuilding(null)
                            setMediaIds([])
                            formRef.current.reset()
                            setAddNew(false)
                            props.setBuildingId(response.data[0])
                            props.nextFormStep()
                        }
                        window.scrollTo({
                            top: 0,
                            behavior: "smooth"
                        })
                    } else {
                        setLoading(false)
                    }
                })
            } else {
                buildingService.create(data).then(response => {
                    if (response && response.status === SuccessCreated) {
                        toast.success("New Buiding has been added")
                        if (goOut) {
                            props ?.history ?.push(`${salesDeveloperPrefix}/compound/compound-list/${filterData?.developer_id}`);
                        } else if (addNew) {
                            setLoading(false)
                            props.updateBulidingList(undefined, {
                                ...data,
                                id: response.data[0],
                                mediaIds: mediaIds,
                                selectedCatogory: formData.selectedCatogory,
                                floor_num: formData.floor_num
                            })
                            setFormData(initialData)
                            setMediaIds([])
                            formRef.current.reset()
                            setAddNew(false)
                        }
                        else {
                            props.updateBulidingList(undefined, {
                                ...data,
                                id: response.data[0],
                                mediaIds: mediaIds,
                                selectedCatogory: formData.selectedCatogory,
                                floor_num: formData.floor_num
                            })
                            setMediaIds([])
                            formRef.current.reset()
                            setAddNew(false)
                            props.setBuildingId(response.data[0])
                            props.nextFormStep()
                        }
                        window.scrollTo({
                            top: 0,
                            behavior: "smooth"
                        })
                    } else {
                        setLoading(false)
                    }
                })
            }

        }
        } >
            {<Row className="py-3">
                {props ?.BuildingData ?.map((item, index) => {
                    return (
                        <Col md={4} sm={6} key={index}>
                            <Card className="mb-3">
                                <CardBody className="p-0">
                                    <CardImg src={item ?.mediaIds[0] ?.path || blankImg} className="imgCard"></CardImg>
                                    <CardText className="pt-2 text-black ps-2  fw-bold">{item.name.en}</CardText>
                                    <CardText className="text-black   fw-bold d-flex  m-2 justify-content-between">
                                        <button type="button" className="btn btn-primary me-2" onClick={() => setEditBuilding(item)}>Edit</button>
                                        <button type="button" className="btn btn-danger" onClick={() => deleteHandler(item.id)}>Delete</button>
                                    </CardText>

                                </CardBody>
                            </Card>
                        </Col>
                    )
                })}
            </Row>}
            <Card >
                <CardBody>
                    <Row className="justify-content-end mb-3">
                        <Col md={2}>
                        <div className="mb-2">
                                <button
                                    className="btn btn-primary btnHeight px-lg-4"
                                    type="button"
                                    onClick={()=>{
                                        dispatch(appendFilters({addBuilding: filterData?.addBuilding == 'addBuildings' ? 'addBuilding' : 'addBuildings'}))
                                    }}
                                >
                                    {filterData?.addBuilding == 'addBuildings' ? 'Add Building' : 'Add Buildings'}
                                    </button>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        {filterData.addBuilding !== "addBuildings" && <Col md={6} className="mb-3">
                                <AvField
                                    name={'en'}
                                    label={`Building Name`}
                                    bsSize="lg"
                                    value={formData?.en}
                                    onChange={(e => handleFieldChange(e))}
                                    required={true}
                                    errorMessage="This field is required"
                                    placeholder={'Building Name'}
                                />
                            </Col>}
                            {filterData.addBuilding == "addBuildings" &&<> 
                                <Col md={6} className="mb-3">
                                    <AvField
                                        name={'title_before_numbers'}
                                        label={`Title Before Numbers (Optional)`}
                                        value={formData?.title_before_numbers}
                                        onChange={(e => handleFieldChange(e))}
                                        required={false}
                                        type='text'
                                        // validate={{
                                        //     pattern: {
                                        //         value: /^(?!.*-$)[a-zA-Z0-9 %!@#$%^&*()_+=~`{}|:;"'<>,.?/\\[\]-]*$/,
                                        //         errorMessage: `this format is invalid`
                                        //     }
                                        // }}
                                        placeholder={'Title Before Numbers'}
                                    />
                                </Col>
                                <Col md={3} >
                                <AvField
                                    name={"from"}
                                    label={"From"}
                                    bsSize="lg"
                                    value={formData.from}
                                    onChange={(e => handleFieldChange(e))}
                                    required
                                    placeholder={'From'}
                                    type="number"
                                    min={"0"}
                                />
                            </Col>
                            <Col md={3}>
                                <AvField
                                    name={"to"}
                                    label={"To"}
                                    bsSize="lg"
                                    value={formData.to}
                                    onChange={(e => handleFieldChange(e))}
                                    required
                                    placeholder={'To'}
                                    type="number"
                                    min={`${parseInt(formData.from)+1}`}

                                />
                            </Col>
                            </>}

                        <Col md={6}  >
                            <AvField
                                className="mb-3"
                                name={"floor_num"}
                                label={"Building Floors"}
                                errorMessage="This field is required"
                                bsSize="lg"
                                value={formData.floor_num}
                                onChange={(e => handleFieldChange(e))}
                                required
                                placeholder={'Floor Number'}
                                type="number"
                                min={"1"}
                                max={"200"}

                            />
                        </Col>
                        <Col md={6}>
                            <SelectOptions
                                label='Building Category'
                                placeholder='Select'
                                options={catogoryOptions}
                                handleSelectChange={(data) => {
                                    setFormData({ ...formData, selectedCatogory: data });
                                }}
                                selectedOption={formData.selectedCatogory}
                                Service={CategoriesService}
                                setOptions={(options) => {
                                    setCatogoryOptions(options)
                                }}
                                isMulti={true}
                            />
                        </Col>
                        {/* <Row className="mb-1">
                            <h5>Description</h5>
                        </Row> */}
                        {Language.LIST.map((lan, index) => {
                            return (
                                <Col md={12} key={index} >
                                    <AvField
                                        className="mb-3"
                                        name={lan.descrip_name}
                                        label={`Description (${lan.name})`}
                                        bsSize="lg"
                                        value={formData[`${lan.descrip_name}`]}
                                        onChange={(e => handleFieldChange(e))}
                                        required={false}
                                        type="textarea"
                                        placeholder={lan.name === "en" ? 'Building Description' : lan.name === "ar" ? "وصف المبنى" : lan.name === "zh" ? "開羅" : "Каир"}
                                    />
                                </Col>
                            )
                        })}
                    </Row>
                </CardBody>
            </Card >
            <Card >
                <CardBody>
                    <Row>
                        <Col md={12}>
                            <FileUpload
                                accept='.jpg,.png,.jpeg,.JPG,.PNG,.JPEG'
                                label='Building Images'
                                attachmentType='media_id'
                                setUpload={()=> {}}
                                attachmentData={mediaIds}
                                updatedAttachment={updatedAttachment}
                                deleteAttachment={deleteAttachment}
                                multiple
                                setUploadState={setUploadState}

                            />
                        </Col>
                    </Row>
                </CardBody>
            </Card >
            <Row className={"mt-4"}>
                {!props.fromParams &&
                    <Col md={6}>
                        <button
                            type="submit"
                            className="bg-light text-success border-0 btn-hover"
                            // disabled={loading ? true : false}
                            disabled={uploadState ? true : loading ? true : false}

                            onClick={() => {
                                setAddNew(true)
                            }}
                        ><i className="fas fa-plus-circle"></i>
                            &nbsp;Submit & Add Another Building</button>
                    </Col>
                }
            </Row>

            {props.fromParams ?

                <Row className="d-flex justify-content-between pb-4">
                    <Col>
                        <button
                            type="button"
                            className="btn btnUpload btnHeight px-4"
                            onClick={() => {
                                setModal(true)
                            }}
                            size={"lg"}>
                            Cancel
                </button>
                    </Col>
                    <Col>
                        <button
                            type='submit'
                            className="btn btn-success btnHeight px-4 float-end"
                            size={"lg"}
                            onClick={() => {
                                setGoOut(true)
                            }}
                            disabled={uploadState ? true : loading ? true : false}

                        >
                            Submit
                  </button>
                    </Col>
                </Row> :
                <Row className="mt-4">
                    <Card>
                        <CardBody>
                            <Row className="d-flex justify-content-between">
                                <Col md={2}>
                                    <button type="button" onClick={() => setModal(true)} className="btn btn-light btnHeight  w-100  ">Skip</button>
                                </Col>
                                <Col md={2} className="d-flex flex-row-reverse">
                                    <button type="submit" className="btn btn-success btnHeight  w-100 "
                                        disabled={uploadState ? true : loading ? true : false}
                                    >Continue</button>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Row>}
            <CancelModal modal={modal}
                toggle={() => setModal(!modal)}
                btnOne={props.fromParams ? "Cancel" : "Continue"}
                btnTwo={props.fromParams ? "GO back" : "Skip"}
                btnTwoOclick={() => {
                    if (props.fromParams) {
                        props.history.push(`${salesDeveloperPrefix}/compound/compound-list/${filterData?.developer_id}`)
                    } else {
                        props.nextFormStep()
                        window.scrollTo({
                            top: 0,
                            behavior: "smooth"
                        })
                    }

                }}
                btnOneClick={() => setModal(false)}
            />

        </AvForm >
    )
}

export default BuildingForm 